import { useCallback, useEffect, useState } from 'preact/hooks'
import { api, type ErrorMessages, errorMessage } from './client'

/** Loads `GET /api{path}`, reloading when `path` changes or on `reload()`; does nothing while `path` is null. */
export function useApi<T>(path: string | null, messages?: ErrorMessages) {
  const [data, setData] = useState<T>()
  const [error, setError] = useState<string>()
  const [version, setVersion] = useState(0)
  const reload = useCallback(() => setVersion((v) => v + 1), [])

  useEffect(() => {
    if (path === null) return
    let current = true
    setError(undefined)
    api.get<T>(path).then(
      (result) => current && setData(result),
      (e: unknown) => current && setError(errorMessage(e, messages)),
    )
    return () => {
      current = false
    }
  }, [path, version])

  return { data, setData, error, reload }
}
